module.exports = __webpack_public_path__ + "assets/img/btn-detail-0460a255.png";